import { render, staticRenderFns } from "./formBuilderNewView.vue?vue&type=template&id=412b7988&scoped=true"
import script from "./formBuilderNewView.vue?vue&type=script&lang=js"
export * from "./formBuilderNewView.vue?vue&type=script&lang=js"
import style0 from "./formBuilderNewView.vue?vue&type=style&index=0&id=412b7988&prod&lang=scss&scoped=true"
import style1 from "./formBuilderNewView.vue?vue&type=style&index=1&id=412b7988&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412b7988",
  null
  
)

export default component.exports